import { render, staticRenderFns } from "./kbcx.vue?vue&type=template&id=ebb6d132&scoped=true"
import script from "./kbcx.vue?vue&type=script&lang=js"
export * from "./kbcx.vue?vue&type=script&lang=js"
import style0 from "./kbcx.vue?vue&type=style&index=0&id=ebb6d132&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb6d132",
  null
  
)

export default component.exports